import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import ReactGA from 'react-ga';

import { RootState } from 'app/redux/store';

import { GlobalSearchResponseCollection, SearchState } from '../types';

const initialState: SearchState = {
  cleared: null,
  searchLoading: false,
  searchOpened: false,
  results: [],
  searched: false,
  showResults: false,
  searchText: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchOpenedAction(state, action: PayloadAction<boolean>) {
      state.searchOpened = action.payload;
    },

    setClearSearchAction(state, action: PayloadAction<boolean>) {
      state.cleared = action.payload ? null : new Date().toString();
    },

    setSearchLoadingAction(state, action: PayloadAction<boolean>) {
      state.searchLoading = action.payload;
    },

    setSearchedAction(state, action: PayloadAction<boolean>) {
      state.searched = action.payload;
    },

    clearSearchResultsAction(state) {
      state.results = [];
      state.searchText = '';
      state.searchId = undefined;
      state.currentPage = undefined;
      state.totalPages = undefined;
      state.totalResults = undefined;
      state.limitPerPage = undefined;
      state.showResults = false;
    },

    setSearchResultsAction(state, action: PayloadAction<GlobalSearchResponseCollection>) {
      const { results, searchText, searchId, currentPage, totalPages, totalResults, limitPerPage } = action.payload;

      state.results = results;
      state.searchText = searchText;
      state.searchId = searchId;
      state.currentPage = currentPage;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.limitPerPage = limitPerPage;
      state.showResults = true;
    },
  },
});

export const {
  setSearchOpenedAction,
  setClearSearchAction,
  setSearchResultsAction,
  setSearchLoadingAction,
  setSearchedAction,
  clearSearchResultsAction,
} = searchSlice.actions;

export const getSearch = (state: RootState): SearchState => state.search;

export default searchSlice.reducer;
